import request from '../utils/request';


// 消费维度规则
export function getExpendRulesList(param) {
    return request({
        url: '/admin/spendAmountRule/getSpendAmountRuleList',
        method: 'GET',
        params: param
    })
}

export function createExpendRule(data){
    return request({
        url: '/admin/spendAmountRule/createSpendAmountRule',
        method: 'POST',
        data: data
    })
}

export function updateExpendRule(data){
    return request({
        url: '/admin/spendAmountRule/updateSpendAmountRule',
        method: 'PUT',
        data: data
    })
}

export function resetExpendDefault(data){
    return request({
        url: '/admin/spendAmountRule/updateResetSpendAmountRule',
        method: 'PUT',
        data: data
    })
}

export function getExpendRuleUsers(params){
    return request({
        url: '/admin/spendAmountRule/getSpendAmountRuleUserList',
        method: 'GET',
        params: params
    })
}

export function deleteExpendRule(data) {
    return request({
        url: '/admin/spendAmountRule/deleteSpendAmountRule',
        method: 'DELETE',
        data
    })
}
// 注册时间规则
export function getDateRulesList(param) {
    return request({
        url: '/admin/registrationTimeRule/getRegistrationTimeRuleList',
        method: 'GET',
        params: param
    })
}

export function createDateRule(data){
    return request({
        url: '/admin/registrationTimeRule/createRegistrationTimeRule',
        method: 'POST',
        data: data
    })
}

export function updateDateRule(data){
    return request({
        url: '/admin/registrationTimeRule/updateRegistrationTimeRule',
        method: 'PUT',
        data: data
    })
}

export function resetDateDefault(data){
    return request({
        url: '/admin/registrationTimeRule/updateResetRegistrationTimeRule',
        method: 'PUT',
        data: data
    })
}

export function getDateRuleUsers(params){
    return request({
        url: '/admin/registrationTimeRule/getRegistrationTimeRuleUserList',
        method: 'GET',
        params: params
    })
}

export function deleteDateRule(data) {
    return request({
        url: '/admin/registrationTimeRule/deleteRegistrationTimeRule',
        method: 'DELETE',
        data
    })
}

// 活跃度规则
export function getActivityRulesList(param) {
    return request({
        url: '/admin/activityRule/getActivityRuleList',
        method: 'GET',
        params: param
    })
}

export function createActivityRule(data){
    return request({
        url: '/admin/activityRule/createActivityRule',
        method: 'POST',
        data: data
    })
}

export function updateActivityRule(data){
    return request({
        url: '/admin/activityRule/updateActivityRule',
        method: 'PUT',
        data: data
    })
}

export function resetActivityDefault(data){
    return request({
        url: '/admin/activityRule/updateResetActivityRule',
        method: 'PUT',
        data: data
    })
}

export function getActivityRuleUsers(params){
    return request({
        url: '/admin/activityRule/getActivityRuleUserList',
        method: 'GET',
        params: params
    })
}

export function deleteActivityRule(data) {
    return request({
        url: '/admin/activityRule/deleteActivityRule',
        method: 'DELETE',
        data
    })
}

// 自定义用户

export function getCustomizeRulesList(param) {
    return request({
        url: '/admin/customRule/getCustomRuleList',
        method: 'GET',
        params: param
    })
}

export function createCustomizeRule(data){
    return request({
        url: '/admin/customRule/createCustomRule',
        method: 'POST',
        data: data
    })
}

export function updateCustomizeRule(data){
    return request({
        url: '/admin/customRule/updateCustomRule',
        method: 'PUT',
        data: data
    })
}

export function geCustomizeRuleUsers(params){
    return request({
        url: '/admin/customRule/getCustomRuleUserList',
        method: 'GET',
        params: params
    })
}

export function deleteCustomizeRule(data) {
    return request({
        url: '/admin/customRule/deleteCustomRule',
        method: 'DELETE',
        data
    })
}